import { render, staticRenderFns } from "./CarryForwardModal.vue?vue&type=template&id=0cf0aadd&"
import script from "./CarryForwardModal.vue?vue&type=script&lang=js&"
export * from "./CarryForwardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports